import { render, staticRenderFns } from "./CollapsiblePanel.vue?vue&type=template&id=13250eb4&scoped=true"
import script from "./CollapsiblePanel.vue?vue&type=script&lang=js"
export * from "./CollapsiblePanel.vue?vue&type=script&lang=js"
import style0 from "./CollapsiblePanel.vue?vue&type=style&index=0&id=13250eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13250eb4",
  null
  
)

export default component.exports